import React, {Component} from 'react';

import {ClientActivityLogContent} from "./ClientActivityLogContent";
import {withRouterParams} from "../../utils/withRouterParams";

export class ClientActivityLog extends Component {
    render() {
        return (
            <ClientActivityLogContent clientId={this.props.match.params.id}/>
        )
    }
}

export default withRouterParams(ClientActivityLog);
